//
import { ProductModel } from '@/models'

//
import { generateFetchDataFunction } from '../DataTableService'

//
import ProductAppends from './appends'
import ProductIncludes from './includes'

//
export default generateFetchDataFunction( ProductModel, ProductIncludes, ProductAppends )
